import type { AbsenceDayPart } from './model';

export function absenceDayPartLabel(dayPart: unknown): string {
  return dayPart === 'AM' ? '오전 반차' : dayPart === 'PM' ? '오후 반차' : dayPart === 'AM_QUARTER' ? '오전 반반차' : dayPart === 'PM_QUARTER' ? '오후 반반차' : '';
}

export function absenceDayPartQuantity(dayPart: unknown): number | undefined {
  return dayPart === 'AM' || dayPart === 'PM' ? 0.5 : dayPart === 'AM_QUARTER' || dayPart === 'PM_QUARTER' ? 0.25 : undefined;
}

export function absenceDayPartTimeLabel(dayPart: unknown): string {
  const range = dayPart === 'AM' ? '근무 시작–14:30' : dayPart === 'PM' ? '14:30–근무 종료' : dayPart === 'AM_QUARTER' ? '근무 시작–11:30' : dayPart === 'PM_QUARTER' ? '16:30–근무 종료' : '';
  return range ? `${absenceDayPartLabel(dayPart)} (${range})` : '';
}

export function absenceDayPartError(input: { startDate: string; endDate: string; quantity: string; unitOfTime: string; dayPart?: AbsenceDayPart }): string | undefined {
  const quantity = Number(input.quantity);
  const partialDay = input.unitOfTime === 'DAYS' && (quantity === 0.5 || quantity === 0.25);
  const partQuantity = absenceDayPartQuantity(input.dayPart);
  if (partialDay && input.startDate !== input.endDate) return quantity === 0.25 ? '반반차는 하루를 선택해 주세요.' : '반차는 하루를 선택해 주세요.';
  if (partialDay && partQuantity !== quantity) return quantity === 0.25 ? '오전 반반차 또는 오후 반반차를 선택해 주세요.' : '오전 반차 또는 오후 반차를 선택해 주세요.';
  if (partQuantity !== undefined && (input.unitOfTime !== 'DAYS' || quantity !== partQuantity || input.startDate !== input.endDate)) return '반차·반반차는 같은 날짜에 해당하는 사용량으로 선택해 주세요.';
  return undefined;
}

export function absenceTypeWithDayPart(title: string, dayPart: unknown): string {
  const part = absenceDayPartLabel(dayPart);
  return part ? `${title} · ${part}` : title;
}
